import React, { Fragment, useContext, useState } from "react";
import DataTable from "react-data-table-component";
import { DropdownItem } from "reactstrap";
import moment from "moment";
import { Spinner } from "../../../AbstractElements";
import { otpColumns } from "../../../Data/Users/Otp";
import CustomizerContext from "../../../_helper/Customizer";

const OtpTable = ({
    tableData,
    setShowApiLoader,
    fetchTableData,
    paginationPerPage,
    paginationTotalRows,
    onChangePage,
    onChangeRowsPerPage,
    loader,
    cityData
}) => {

    console.log("cityData", cityData)
    const { mix_background_layout } = useContext(CustomizerContext);

    const processData = tableData.map((element, index) => {
        return {
            id: element.id ? element.id : "-",
            deviceId: element.deviceId ? element.deviceId : "-",
            deviceType: element.deviceType ? element.deviceType : "-",
            mobile: element.mobile ? element.mobile : "-",
            otp: element.otp ? element.otp : "-",
            requestedOn: element.requestedOn ? moment(new Date(element.requestedOn)).format("MMM DD HH:mm") : "-",
            validUpto: element.validUpto ? moment(new Date(element.validUpto)).format("MMM DD HH:mm") : "-",
        };
    });
    return (
        <Fragment>
            <div className="table-responsive">
                <DataTable
                    columns={otpColumns}
                    data={processData}
                    center={true}
                    fixedHeader
                    fixedHeaderScrollHeight={"57vh"}
                    pagination
                    paginationPerPage={paginationPerPage}
                    paginationTotalRows={paginationTotalRows}
                    onChangePage={onChangePage}
                    onChangeRowsPerPage={onChangeRowsPerPage}
                    // customStyles={customStyles}
                    paginationServer
                    progressPending={loader}
                    progressComponent={<div className="loader-box" style={{ height: "57vh" }}>
                        <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
                    </div>}
                    theme={mix_background_layout == "dark-only" ? "dark" : "default"}
                />
            </div>

        </Fragment>
    );
};

export default OtpTable;
